var _path;
import * as React from "react";
function SvgDashedLine(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 18a2 2 0 100 4h3a2 2 0 100-4H5zm9 0a2 2 0 100 4h3a2 2 0 100-4h-3zm7 2a2 2 0 012-2h3a2 2 0 110 4h-3a2 2 0 01-2-2zm11-2a2 2 0 100 4h3a2 2 0 100-4h-3z"
  })));
}
export default SvgDashedLine;